<section class="instructions bg-gray3 text-primary ptb-25">
  <div class="container">
    <div
      class="section-title mrb-30 text-center weight-700 size-35"
      data-aos="fade-up"
      data-aos-duration="1000"
    >
      {{ "header.blog" | translate }}
    </div>

    <div class="row">
      <div
        class="col-12 col-md-6 col-lg-4 mrb-10"
        data-aos="fade-up"
        data-aos-duration="1500"
        *ngFor="let healtheducation of helathEducations"
      >
        <a
          [routerLink]="[
            '/health-education',
            healtheducation?.healthEducationId
          ]"
        >
          <health-education
            title="{{ healtheducation?.title || healtheducation?.titleAr }}"
            image="{{ healtheducation?.foregroundImage }}"
            [healthEducationId]="healtheducation?.healthEducationId"
          ></health-education>
        </a>
      </div>
    </div>
  </div>
</section>
